import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const PlanLockedBanner = ({
  title = "Not included in your plan",
  message = "Upgrade to unlock this feature.",
  showUpgrade = true,
}) => (
  <div className="alert alert-warning d-flex align-items-start gap-2 mb-3" role="status">
    <Icon icon="mdi:lock-outline" width={22} className="mt-1 flex-shrink-0" />
    <div>
      <strong className="d-block">{title}</strong>
      <span className="d-block text-secondary-light">{message}</span>
      {showUpgrade ? (
        <Link to="/plans" className="fw-semibold">
          View plans &amp; orders
        </Link>
      ) : null}
    </div>
  </div>
);

export default PlanLockedBanner;
